var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('app-title',[_vm._v("Upload Logo")]),_c('v-subheader',[_c('h3',[_vm._v("Please Note: Recommended Image size to be : 400px x 400px")])]),_c('file-uploader')],1)}
var staticRenderFns = []

export { render, staticRenderFns }